const fontWeight = 400
const radius = "4px"
const letterSpacing = "-0.006em"
const zIndex = "auto"

export const buttons = {
  themes: {
    default: {
      fill: {
        ...{ fontWeight },
        ...{ radius },
        ...{ letterSpacing },
        ...{ zIndex },
        backgroundColor: "var(--default-btn--background-color)",
        color: "var(--default-btn--color)",
        whiteSpace: "nowrap",
        hover: {
          backgroundColor: "var(--default-btn-hover--background-color)",
          color: "var(--base-button--font-color)"
        }
      },
      outline: {
        ...{ fontWeight },
        ...{ radius },
        ...{ letterSpacing },
        ...{ zIndex },
        color: "var(--default-outline-btn-color)",
        stroke: "var(--default-outline-btn-stroke-color)",
        hover: {
          backgroundColor: "var(--default-outline-btn-hover-background-color)"
        }
      },
      naked: { ...{ fontWeight }, ...{ letterSpacing }, ...{ zIndex }, padding: 0 }
    },
    generic: {
      fill: {
        ...{ fontWeight },
        ...{ radius },
        ...{ letterSpacing },
        backgroundColor: "var(--color--neutral-050)",
        color: "var(--base-button--font-color)",
        stroke: "var(--default-outline-btn-stroke-color)",
        hover: {
          backgroundColor: "var(--color--neutral-100)",
          color: "var(--base-button--font-color)",
          stroke: "var(--default-outline-btn-stroke-color)"
        }
      }
    },
    app: {
      fill: {
        ...{ fontWeight },
        ...{ radius },
        ...{ letterSpacing },
        backgroundColor: "var(--app-btn--background-color)",
        color: "var(--color--white)",
        hover: {
          backgroundColor: "var(--app-btn-hover--background-color)",
          color: "var(--color--white)"
        }
      },
      naked: {
        ...{ letterSpacing },
        ...{ fontWeight },
        ...{ zIndex },
        color: "var(--high-contrast-btn-color)",
        paddingLeft: 0,
        paddingRight: 0
      },
      outline: {
        ...{ fontWeight },
        ...{ letterSpacing },
        stroke: "var(--app-outline-btn-stroke-color)",
        color: "var(--app-outline-btn-stroke-color)",
        hover: {
          backgroundColor: "var(--app-outline-btn-hover-background-color)",
          color: "var(--app-outline-btn-stroke-color)"
        }
      }
    },
    create: {
      fill: {
        ...{ fontWeight },
        ...{ radius },
        ...{ letterSpacing },
        backgroundColor: "var(--create-btn--background-color)",
        color: "var(--color--white)",
        hover: {
          backgroundColor: "var(--create-btn-hover--background-color)",
          color: "var(--color--white)"
        }
      },
      outline: {
        ...{ fontWeight },
        ...{ letterSpacing },
        color: "var(--create-outline-btn-stroke-color)",
        stroke: "var(--create-outline-btn-stroke-color)",
        hover: {
          backgroundColor: "var(--create-outline-btn-hover-background-color)",
          color: "var(--create-outline-btn-stroke-color)"
        }
      }
    },
    destroy: {
      fill: {
        ...{ fontWeight },
        ...{ radius },
        ...{ letterSpacing },
        ...{ zIndex },
        backgroundColor: "var(--destroy-btn--background-color)",
        color: "var(--color--white)",
        hover: {
          backgroundColor: "var(--destroy-btn-hover--background-color)",
          color: "var(--color--white)"
        }
      },
      outline: {
        ...{ fontWeight },
        ...{ letterSpacing },
        ...{ zIndex },
        color: "var(--destroy-outline-btn-stroke-color)",
        stroke: "var(--destroy-outline-btn-stroke-color)",
        hover: {
          backgroundColor: "var(--destroy-outline-btn-hover-background-color)",
          color: "var(--destroy-outline-btn-stroke-color)"
        }
      },
      naked: {
        ...{ fontWeight },
        ...{ zIndex },
        color: "var(--destroy-naked-btn--text-color)",
        paddingLeft: 0,
        paddingRight: 0
      }
    },
    highContrast: {
      fill: {
        backgroundColor: "var(--color--white)",
        color: "var(--high-contrast-btn-color)",
        ...{ fontWeight },
        ...{ radius },
        ...{ letterSpacing },
        ...{ zIndex },
        hover: {
          backgroundColor: "var(--high-contrast-btn-hover--background-color)",
          color: "var(--high-contrast-btn-color)"
        }
      },
      outline: {
        borderColor: "var(--color--white)",
        color: "var(--color--white)",
        ...{ fontWeight },
        ...{ radius },
        ...{ letterSpacing },
        ...{ zIndex }
      }
    },
    filterBar: {
      fill: {
        backgroundColor: "var(--color--brand-91)",
        ...{ radius },
        ...{ letterSpacing },
        ...{ zIndex }
      }
    },
    flat: {
      fill: {
        ...{ fontWeight },
        ...{ radius },
        ...{ letterSpacing },
        backgroundColor: "transparent",
        color: "var(--base-button--font-color)",
        stroke: "transparent",
        hover: {
          backgroundColor: "var(--color--neutral-100)",
          color: "var(--base-button--font-color)",
          stroke: "transparent"
        }
      }
    },
    link: {
      fill: {
        ...{ fontWeight },
        ...{ letterSpacing },
        ...{ zIndex },
        paddingLeft: 0,
        paddingRight: 0,
        backgroundColor: "transparent",
        color: "var(--colors-link-foreground)",
        hover: {
          textDecoration: "underline",
          color: "var(--colors-link-foreground)"
        }
      }
    }
  }
}
